function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStylusAiSearch = function SvgStylusAiSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 283.46 283.46"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m273.61 284.44-78.22-78.22c-20.84 18.32-48.16 29.45-78.02 29.45-65.26 0-118.36-53.06-118.36-118.28C-.99 52.13 52.11-.97 117.37-.97c65.22 0 118.3 53.1 118.3 118.36 0 29.86-11.13 57.18-29.47 78.02l78.22 78.2zM117.37 14.31C60.53 14.31 14.3 60.54 14.3 117.38c0 56.78 46.23 102.99 103.07 102.99 56.8 0 103.01-46.21 103.01-102.99 0-56.84-46.21-103.07-103.01-103.07",
    style: {
      fill: "#ff6269"
    }
  }));
};
export default SvgStylusAiSearch;